import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { config } from '../../function/config'
import { toast } from 'react-toastify'
import AdminHeader from './AdminHeader'

export default function EditNewAdmission() {
  const { id } = useParams()
  const navigate = useNavigate()
  const token = localStorage.getItem('token')

  const [loading, setLoading] = useState(false)

  const [formData, setFormData] = useState({
    first_name:'',
    last_name:'',
    age:'',
    dob:'',
    orphan_status:'',
    guardian_details:'',
    address:'',
    remarks:'',
    identification_mark:'',
    gender:'',
    blood_group:'',
    category:'',
  })

  const [errors, setErrors] = useState({
    first_name:'',
    last_name:'',
    age:'',
    dob:'',
    orphan_status:'',
    guardian_details:'',
    address:'',
    remarks:'',
    identification_mark:'',
    gender:'',
    blood_group:'',
    category:'',
  })

  const fetchNewAdmission = async() => {
    try{
      const res = await axios.get(`${config.baseurl}get_all_new_admissions/`, {
        headers:{
          'Content-Type':'application/json',
          'Authorization':`Token ${token}`
        }
      })
      console.log('All New Admissions:', res.data)

      if(res.status === 200){
        const selectedAdmission = res.data.data.find((item) => String(item.id) === String(id))
        if(selectedAdmission){
          setFormData({
            first_name:selectedAdmission.first_name || '',
            last_name:selectedAdmission.last_name || '',
            age:selectedAdmission.age?.toString() || '',
            dob:selectedAdmission.dob || '',
            orphan_status:selectedAdmission.orphan_status || '',
            guardian_details:selectedAdmission.guardian_details || '',
            address:selectedAdmission.address || '',
            remarks:selectedAdmission.remarks || '',
            identification_mark:selectedAdmission.identification_mark || '',
            gender:selectedAdmission.gender || '',
            blood_group:selectedAdmission.blood_group || '',
            category:selectedAdmission.category || '',
          })
        }else{
          toast.error('New Admission not found')
          navigate('admin/all_new_admissions')
        }
      }
    }catch(error){
      console.log('Error:', error.response?.data || error)

      const message =
        error.response?.data?.message ||
        error.response?.data?.error ||
        'Failed to create branch'

      toast.error(message)
    }
  }

  useEffect(() => {
    if(id){
      fetchNewAdmission()
    }
  },[id, token, navigate])

  const handleChange = (e) => {
    const {name, value} = e.target

    setFormData((prev) => ({
      ...prev,
      [name]:value
    }))
  }

  const validateForm = () => {
    const newErrors = {}

    if(!formData.first_name.trim()){
      newErrors.first_name = 'First name is required'
    }

    if(!formData.last_name.trim()){
      newErrors.last_name = 'Last name is required'
    }

    if(!formData.age){
      newErrors.age = 'Age is required'
    }

    if(!formData.dob){
      newErrors.dob = 'Date of birth is required'
    }

    if(!formData.orphan_status){
      newErrors.orphan_status = 'First name is required'
    }

    if(formData.orphan_status === 'No' && !formData.guardian_details.trim()){
      newErrors.guardian_details = 'Graduate Details is required'
    }

    if(formData.orphan_status === 'No' && !formData.address.trim()){
      newErrors.address = 'Address is required'
    }

    if(!formData.identification_mark.trim()){
      newErrors.identification_mark = 'Identification Mark is required'
    }

    if(!formData.gender){
      newErrors.gender = 'Please Select Gender'
    }

    if(!formData.blood_group){
      newErrors.blood_group = 'Please Select Blood Group'
    }

    if(!formData.category){
      newErrors.category = 'Please Select Caegory'
    }

    setErrors(newErrors)

    return Object.keys(newErrors).length === 0
  }

  const handleUpdate = async(e) => {
    e.preventDefault()

    const validationErrors = validateForm(formData)

    setErrors(validationErrors)

    if(Object.keys(validationErrors).length > 0){
      return
    }

    setLoading(true)

    try{
      const payload = {
        first_name:formData.first_name.trim(),
        last_name:formData.last_name.trim(),
        age:Number(formData.age),
        dob:formData.dob.trim(),
        orphan_status:formData.orphan_status.trim(),
        guardian_details:formData.guardian_details.trim(),
        address:formData.address.trim(),
        remarks:formData.remarks.trim(),
        identification_mark:formData.identification_mark.trim(),
        gender:formData.gender.trim(),
        blood_group:formData.blood_group.trim(),
        category:formData.category.trim(),
      }
      console.log('Updating New Admission Id:', id)
      console.log('Payload:', payload)

      const res = await axios.put(`${config.baseurl}update_new_admission/${id}/`, payload, {
        headers:{
          'Content-Type':'application/json',
          'Authorization':`Token ${token}`
        }
      })
      console.log('Sending Data:', formData)

      if(res.status === 200){
        toast.success('New Admission Updated Successfully')
        navigate('/admin/all_new_admissions')
      }else{
        toast.error('Error occured while updating staff')
      }
    }catch(error){
      console.log('Update new admission error:', error.response?.data)

      const message =
        error.response?.data?.error?.[0] ||
        error.response?.data?.message ||
        'Error occurred'

      toast.error(message)
    }finally{
      setLoading(false)
    }
  }
    
  const inputClass ='w-full rounded-xl border border-slate-300 bg-white px-4 py-3 text-sm text-slate-800 outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100 placeholder:text-slate-400'

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100 ml-64 5xl:ml-0">
      <AdminHeader/>

      {/* HEADER */}
      <div className="max-w-7xl mx-auto px-6 pt-16 pb-6">
        <div className="items-center justify-between text-center">
          <h1 className="mt-1 text-3xl font-bold text-slate-800">
            Edit New Admissions
          </h1>

          <p className="mt-2 text-sm text-slate-500">
            Update a new admissions.
          </p>
        </div>
      </div>

      {/* FORM SECTION */}
      <div className="max-w-7xl mx-auto px-6 pb-12">            
        <div className="mx-auto max-w-5xl overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-lg">

          {/* Form */}
          <form onSubmit={handleUpdate} className="p-6 md:p-8">
            <div className="grid grid-cols-1 gap-6 md:grid-cols-2">

              {/* First Name */}
            <div className="md:col-span-2">
              <label
                htmlFor="first_name"
                className="mb-2 block text-sm font-semibold text-slate-700"
              >
                First Name
                <span className="ml-1 text-red-500">
                    *
                </span>
              </label>

              <input
                id="first_name"
                type="text"
                name="first_name"
                placeholder="Enter first name"
                value={formData.first_name}
                onChange={handleChange}
                className={`${inputClass} ${errors.first_name
                  ? 'border-red-500 focus:border-red-600'
                  : ''
                }`}
              />

              {errors.first_name && (
                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.first_name}</p>
              )}
            </div>

            {/* Last Name */}
            <div className="md:col-span-2">
              <label
                htmlFor="last_name"
                className="mb-2 block text-sm font-semibold text-slate-700"
              >
                Last Name
                <span className="ml-1 text-red-500">
                  *
                </span>
              </label>

              <input
                id="last_name"
                type="text"
                name="last_name"
                placeholder="Enter last name"
                value={formData.last_name}
                onChange={handleChange}
                className={`${inputClass} ${errors.last_name
                  ? 'border-red-500 focus:border-red-600'
                  : ''
                }`}
              />

              {errors.last_name && (
                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.last_name}</p>
              )}
            </div>

            {/* Age */}
            <div className="md:col-span-2">
              <label
                htmlFor="age"
                className="mb-2 block text-sm font-semibold text-slate-700"
              >
                Age
                <span className="ml-1 text-red-500">
                  *
                </span>
              </label>

              <input
                id="age"
                type="number"
                name="age"
                placeholder="Enter Age"
                value={formData.age}
                onChange={handleChange}
                className={`${inputClass} ${errors.age
                  ? 'border-red-500 focus:border-red-600'
                  : ''
                }`}
              />

              {errors.age && (
                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.age}</p>
              )}
            </div>

            {/* Date of Birth */}
            <div className="md:col-span-2">
              <label
                htmlFor="dob"
                className="mb-2 block text-sm font-semibold text-slate-700"
              >
                Date of Birth
                <span className="ml-1 text-red-500">
                  *
                </span>
              </label>

              <input
                id="dob"
                type="date"
                name="dob"
                placeholder="Enter Date of Birth"
                value={formData.dob}
                onChange={handleChange}
                className={`${inputClass} ${errors.dob
                  ? 'border-red-500 focus:border-red-600'
                  : ''
                }`}
              />

              {errors.dob && (
                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.dob}</p>
              )}
            </div>

            {/* Orphan or Not */}
            <div className="md:col-span-2">
              <label
                htmlFor="orphan_status"
                className="mb-2 block text-sm font-semibold text-slate-700"
              >
                Orphan or Not
                <span className="ml-1 text-red-500">
                  *
                </span>
              </label>

              <select
                id="orphan_status"
                name="orphan_status"
                value={formData.orphan_status}
                onChange={handleChange}
                className={`${inputClass} ${errors.orphan_status
                  ? 'border-red-500 focus:border-red-600'
                  : ''
                }`}
              >
                <option value="">Select Orphan or not</option>
                <option value="No">No</option>
                <option value="Yes">Yes</option>
              </select>

              {errors.orphan_status && (
                  <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.orphan_status}</p>
              )}
            </div>

            {formData.orphan_status === 'No' && (
              <div>
                {/* Guardian Details */}
                <div className="md:col-span-2">
                  <label
                    htmlFor="first_name"
                    className="mb-2 block text-sm font-semibold text-slate-700"
                  >
                    Guardian Name
                    <span className="ml-1 text-red-500">
                        *
                    </span>
                  </label>

                  <input
                    id="guardian_details"
                    type="text"
                    name="guardian_details"
                    placeholder="Enter first name"
                    value={formData.guardian_details}
                    onChange={handleChange}
                    className={`${inputClass} ${errors.guardian_details
                      ? 'border-red-500 focus:border-red-600'
                      : ''
                    }`}
                  />

                  {errors.guardian_details && (
                    <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.guardian_details}</p>
                  )}
                </div>

                {/* Address */}
                <div className="md:col-span-2">
                  <label
                    htmlFor="address"
                    className="mb-2 block text-sm font-semibold text-slate-700"
                  >
                    Address
                    <span className="ml-1 text-red-500">
                      *
                    </span>
                  </label>

                  <textarea
                    id="address"
                    name="address"
                    rows={4}
                    placeholder="Enter complete branch address"
                    value={formData.address}
                    onChange={handleChange}
                    className={`${inputClass} ${errors.address
                      ? 'border-red-500 focus:border-red-600'
                      : ''
                    }`}
                  />

                  {errors.address && (
                    <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.address}</p>
                  )}
                </div>
              </div>
            )}

            {/* Gender */}
            <div className="md:col-span-2">
                <label
                  htmlFor="gender"
                  className="mb-2 block text-sm font-semibold text-slate-700"
                >
                  Gender
                  <span className="ml-1 text-red-500">
                    *
                  </span>
                </label>

                <select
                  id="gender"
                  name="gender"
                  value={formData.gender}
                  onChange={handleChange}
                  className={`${inputClass} ${errors.gender
                    ? 'border-red-500 focus:border-red-600'
                    : ''
                  }`}
                >
                  <option value="">Select Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </select>

                {errors.gender && (
                  <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.gender}</p>
                )}
            </div>

            {/* Remarks */}
            <div className="md:col-span-2">
              <label
                htmlFor="remarks"
                className="mb-2 block text-sm font-semibold text-slate-700"
              >
                Remarks
                <span className="ml-1 text-red-500">
                  *
                </span>
              </label>

              <textarea
                id="remarks"
                name="remarks"
                rows={3}
                placeholder="Enter complete branch remarks"
                value={formData.remarks}
                onChange={handleChange}
                className={`${inputClass} ${errors.remarks
                  ? 'border-red-500 focus:border-red-600'
                  : ''
                }`}
              />

              {errors.remarks && (
                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.remarks}</p>
              )}
            </div>

              {/* Identification Mark */}
            <div className="md:col-span-2">
              <label
                htmlFor="identificaion_mark"
                className="mb-2 block text-sm font-semibold text-slate-700"
              >
                Identification Mark
                <span className="ml-1 text-red-500">
                    *
                </span>
              </label>

              <input
                id="identification_mark"
                type="text"
                name="identification_mark"
                placeholder="Enter first name"
                value={formData.identification_mark}
                onChange={handleChange}
                className={`${inputClass} ${errors.identification_mark
                  ? 'border-red-500 focus:border-red-600'
                  : ''
                }`}
              />

              {errors.identification_mark && (
                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.identification_mark}</p>
              )}
            </div>

            {/* Blood Group */}
            <div>
                <label
                  htmlFor="blood_group"
                  className="mb-2 block text-sm font-semibold text-slate-700"
                >
                  Blood Group
                  <span className="ml-1 text-red-500">
                    *
                  </span>
                </label>

                <select
                  id="blood_group"
                  name="blood_group"
                  value={formData.blood_group}
                  onChange={handleChange}
                  className={`${inputClass} ${errors.blood_group
                    ? 'border-red-500 focus:border-red-600'
                    : ''
                  }`}
                >
                  <option value="">Select Blood Group</option>
                  <option value="A+">A+</option>
                  <option value="A-">A-</option>
                  <option value="B+">B+</option>
                  <option value="B-">B-</option>
                  <option value="AB+">AB+</option>
                  <option value="AB-">AB-</option>
                  <option value="O+">O+</option>
                  <option value="O-">O-</option>
                </select>

                {errors.blood_group && (
                  <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.blood_group}</p>
                )}
            </div>

            {/* Category */}
            <div className="md:col-span-2">
                <label
                  htmlFor="category"
                  className="mb-2 block text-sm font-semibold text-slate-700"
                >
                  Category
                  <span className="ml-1 text-red-500">
                    *
                  </span>
                </label>

                <select
                  id="category"
                  name="category"
                  value={formData.category}
                  onChange={handleChange}
                  className={`${inputClass} ${errors.category
                    ? 'border-red-500 focus:border-red-600'
                    : ''
                  }`}
                >
                  <option value="">Select Category</option>
                  <option value="Aged Person">Aged Person</option>
                  <option value="Child">Child</option>
                </select>

                {errors.category && (
                  <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.category}</p>
                )}
            </div>
          </div>

            {/* Form Actions */}
            <div className="mt-8 flex flex-col-reverse gap-3 border-t border-slate-200 pt-6 sm:flex-row justify-end">
              <button
                type="button"
                onClick={() => navigate(-1)}
                disabled={loading}
                className="rounded-xl bg-slate-100 px-6 py-3 text-sm font-semibold text-slate-700 transition hover:bg-slate-200 disabled:cursor-not-allowed disabled:opacity-50"
              >
                Cancel
              </button>

              <button
                type="submit"
                disabled={loading}
                className="rounded-xl bg-[#000435] px-7 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-[#000326] disabled:cursor-not-allowed disabled:opacity-50"
              >
                {loading ? 'Updating...' : 'Update'}
              </button>
            </div>
          </form>
        </div>
      </div>

    </div>
  )
}
